import { IconProps } from './type';

const NoItemsFound = (
  props: IconProps & {
    description?: string;
  },
) => {
  return (
    <div
      className="relative"
      style={{
        width: props.w ?? '583px',
        height: props.h ?? '485px',
      }}>
      <div>
        <div className="absolute w-[65%] space-y-3 top-[25px] left-8">
          <h3 className="text-secondary-900 font-[700]">No Items Found</h3>
          <h3 className="font-[500]  leading-5">{props.description ?? ''}</h3>
        </div>
        <svg
          width={props.w ?? '583px'}
          height={props.h ?? '485px'}
          viewBox="0 0 583 485"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M452.796 60.1344C459.07 75.7621 451.493 93.5208 435.866 99.7955C420.238 106.07 402.479 98.4932 396.205 82.8655C389.93 67.2379 397.507 49.4792 413.134 43.2045C428.762 36.9298 446.521 44.5068 452.796 60.1344Z"
            fill="#22CC7A"
          />
          <path
            d="M89.7955 263.134C96.0702 278.762 88.4932 296.521 72.8656 302.795C57.2379 309.07 39.4792 301.493 33.2045 285.866C26.9298 270.238 34.5068 252.479 50.1344 246.205C65.7621 239.93 83.5208 247.507 89.7955 263.134Z"
            fill="#E7C0ED"
          />
          <path
            d="M581.989 484.453H1.01127C0.451703 484.453 0 484.001 0 483.442C0 482.882 0.451703 482.43 1.01127 482.43H581.989C582.548 482.43 583 482.882 583 483.442C583 484.001 582.548 484.453 581.989 484.453Z"
            fill="#682082"
          />
          <path
            d="M498.464 483.988C478.191 452.435 421.87 371.349 405.056 375.064C394.559 377.377 391.357 404.823 388.525 429.041C385.95 451.073 383.725 470.106 376.599 473.167C374.489 474.07 372.109 473.551 369.54 471.623C353.373 459.501 348.708 462.825 342.802 467.039C340.732 468.515 338.393 470.18 335.42 471.299C325.617 474.974 311.763 462.805 293.061 434.097L290.978 430.895C272.316 402.174 222.737 325.861 196.781 327.466C192.115 327.749 188.542 330.574 185.839 336.095C175.079 358.122 184.672 399.962 191.016 427.645C195.736 448.215 197.677 457.391 194.293 459.204C192.473 460.182 189.87 458.692 185.603 454.209C174.29 442.316 165.761 430.672 159.539 422.171C153.424 413.817 148.61 407.237 146.096 407.473C145.442 407.54 144.808 408.221 144.221 409.502C142.462 413.339 143.608 423.317 144.707 432.964C146.305 446.927 147.956 461.369 142.522 465.326C140.54 466.769 137.83 466.722 134.466 465.191C123.976 460.425 110.431 461.395 99.9679 467.666C93.2328 471.704 89.0057 477.334 88.6551 482.72L86.6393 482.592C87.0371 476.45 91.5136 470.376 98.9297 465.933C107.694 460.681 121.859 457.242 135.302 463.351C137.992 464.571 139.967 464.686 141.336 463.688C145.819 460.425 144.161 445.956 142.698 433.194C141.511 422.811 140.385 413.008 142.381 408.66C143.298 406.657 144.444 405.605 145.887 405.464C149.534 405.086 153.667 410.736 161.164 420.977C167.353 429.438 175.834 441.021 187.059 452.813C191.94 457.944 193.201 457.492 193.329 457.424C195.493 456.258 192.061 441.298 189.041 428.097C182.63 400.131 172.941 357.872 184.018 335.205C187.025 329.057 191.273 325.773 196.653 325.443C208.356 324.715 225.602 338.448 247.897 366.212C266.019 388.777 283.352 415.455 292.67 429.789L294.753 432.991C316.994 467.133 328.759 471.63 334.705 469.405C337.429 468.387 339.559 466.863 341.622 465.394C347.939 460.89 353.393 457 370.747 470.012C372.729 471.495 374.374 471.92 375.796 471.313C381.851 468.711 384.224 448.431 386.516 428.811C389.563 402.713 392.718 375.718 404.618 373.095C413.841 371.059 432.745 389 460.831 426.405C481.583 454.04 499.974 482.619 500.156 482.902L498.457 483.995L498.464 483.988Z"
            fill="#22CC7A"
          />
          <mask
            id="mask0_3605_25314"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="261"
            y="216"
            width="87"
            height="76">
            <path
              d="M327.765 216.04L261.005 242.851L280.72 291.944L347.48 265.134L327.765 216.04Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_3605_25314)">
            <path
              d="M322.637 236.239C324.977 242.065 322.152 248.678 316.327 251.018C310.502 253.357 303.888 250.532 301.549 244.707C299.209 238.882 302.034 232.268 307.859 229.929C313.684 227.589 320.298 230.414 322.637 236.239Z"
              fill="#E7C0ED"
            />
            <path
              d="M309.899 287.488C316.766 277.746 314.435 264.282 304.694 257.415C294.952 250.548 281.488 252.878 274.621 262.62C267.754 272.362 270.085 285.826 279.826 292.693C289.568 299.56 303.032 297.23 309.899 287.488Z"
              fill="#22CC7A"
            />
            <mask
              id="mask1_3605_25314"
              style={{
                maskType: 'luminance',
              }}
              maskUnits="userSpaceOnUse"
              x="270"
              y="253"
              width="44"
              height="44">
              <path
                d="M309.899 287.488C316.766 277.746 314.435 264.282 304.694 257.415C294.952 250.548 281.488 252.878 274.621 262.62C267.754 272.362 270.085 285.826 279.826 292.693C289.568 299.56 303.032 297.23 309.899 287.488Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_3605_25314)">
              <path
                d="M357.108 260.322C361.814 272.033 353.198 286.521 337.874 292.677C322.549 298.832 306.308 294.329 301.603 282.611C296.897 270.9 305.513 256.412 320.837 250.256C336.161 244.101 352.402 248.604 357.108 260.322Z"
                fill="#682082"
              />
            </g>
            <path
              d="M351.379 270.751C356.699 255.114 351.325 239.142 339.375 235.076C327.425 231.01 313.425 240.391 308.105 256.028C302.785 271.665 308.159 287.637 320.109 291.703C332.059 295.769 346.059 286.388 351.379 270.751Z"
              fill="#22CC7A"
            />
          </g>
          <path
            d="M327.428 216.176L260.668 242.987L280.383 292.081L347.143 265.27L327.428 216.176Z"
            stroke="#682082"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M211.382 229.594C217.926 220.958 216.229 208.652 207.593 202.108C198.957 195.565 186.652 197.261 180.108 205.897C173.565 214.533 175.261 226.839 183.897 233.383C192.533 239.927 204.838 238.231 211.382 229.594Z"
            fill="#D9D9D9"
          />
          <path
            d="M198.567 238.186C187.3 239.739 176.866 231.833 175.313 220.566C173.76 209.298 181.666 198.864 192.933 197.311C204.2 195.758 214.633 203.665 216.187 214.932C217.74 226.199 209.834 236.633 198.567 238.186ZM193.209 199.315C183.044 200.716 175.915 210.124 177.317 220.29C178.718 230.455 188.126 237.584 198.291 236.182C208.456 234.781 215.584 225.373 214.183 215.208C212.782 205.043 203.374 197.914 193.209 199.315Z"
            fill="#D9D9D9"
          />
          <path
            d="M191.684 227.899L188.974 208.828C188.919 208.434 189.307 208.136 189.674 208.282L205.628 214.91C205.968 215.054 206.05 215.499 205.785 215.753L192.549 228.201C192.248 228.488 191.754 228.311 191.692 227.904L191.684 227.899Z"
            fill="white"
          />
          <path
            d="M192.392 229.332C192.158 229.365 191.917 229.343 191.681 229.26C191.144 229.069 190.76 228.604 190.675 228.038L187.965 208.967C187.891 208.426 188.109 207.886 188.538 207.547C188.969 207.216 189.55 207.136 190.055 207.345L206.008 213.966C206.485 214.166 206.829 214.588 206.92 215.1C207.011 215.611 206.844 216.124 206.464 216.483L193.228 228.931C192.993 229.154 192.699 229.29 192.392 229.332ZM190.094 209.552L192.546 226.8L204.518 215.547L190.094 209.552Z"
            fill="white"
          />
          <path
            d="M498 125.685L522.399 116.913L502.868 102L498 125.685Z"
            fill="#E7C0ED"
          />
          <path
            d="M106.416 376.667L96.889 352.553L82.591 372.539L106.416 376.667Z"
            fill="#E7C0ED"
          />
          <path
            d="M538.322 483.091L243.299 482.646L245.045 270.812L540.075 271.257L538.322 483.091Z"
            fill="white"
          />
          <mask
            id="mask2_3605_25314"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="243"
            y="270"
            width="298"
            height="214">
            <mask
              id="mask3_3605_25314"
              style={{
                maskType: 'luminance',
              }}
              maskUnits="userSpaceOnUse"
              x="243"
              y="270"
              width="298"
              height="214">
              <path
                d="M538.322 483.091L243.299 482.646L245.045 270.812L540.075 271.257L538.322 483.091Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_3605_25314)">
              <path
                d="M538.322 483.091L243.299 482.646L245.045 270.812L540.075 271.257L538.322 483.091Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask2_3605_25314)">
            <path
              d="M559.12 500L385.646 499.737L387.453 249.744L560.927 250.007L559.12 500Z"
              fill="#E7C0ED"
            />
            <path
              d="M558.264 358.863L358.645 358.566L341.696 273.098L541.315 273.395L558.264 358.863Z"
              fill="#682082"
            />
            <path
              d="M211.97 358.344L339.728 358.533L356.94 273.118L229.182 272.923L211.97 358.344Z"
              fill="#682082"
            />
          </g>
          <path
            d="M538.322 483.091L243.299 482.646L245.045 270.812L540.075 271.257L538.322 483.091Z"
            stroke="#682082"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M202.7 342.669L330.458 342.864L347.649 270.967L219.892 270.772L202.7 342.669Z"
            fill="white"
          />
          <path
            d="M202.7 342.669L330.458 342.864L347.649 270.967L219.892 270.772L202.7 342.669Z"
            stroke="#682082"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M565.626 343.222L366.007 342.918L349.038 270.968L548.657 271.271L565.626 343.222Z"
            fill="#E7C0ED"
          />
          <path
            d="M565.626 343.222L366.007 342.918L349.038 270.968L548.657 271.271L565.626 343.222Z"
            stroke="#682082"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M472.225 237.925C470.654 237.925 469.023 236.981 467.371 235.12C461.708 228.736 457.076 213.404 455.343 207.114C452.141 195.457 450.442 184.616 451.211 180.76C451.258 180.524 451.406 180.315 451.615 180.193C451.824 180.072 452.08 180.045 452.31 180.126C452.782 180.288 463.825 184.083 466.508 187.839C468.76 190.987 480.12 226.234 475.832 235.41C474.928 237.345 473.533 237.844 472.515 237.925C472.414 237.932 472.313 237.939 472.211 237.939L472.225 237.925ZM452.748 182.068C452.08 191.115 460.171 224.441 468.638 233.994C470.02 235.559 471.288 236.3 472.394 236.219C472.926 236.179 473.701 235.977 474.308 234.682C478.266 226.207 467.303 191.843 465.139 188.816C463.359 186.322 456.321 183.375 452.755 182.068H452.748Z"
            fill="#682082"
          />
          <path
            d="M472.225 237.925C470.654 237.925 469.023 236.981 467.371 235.12C461.708 228.736 457.076 213.404 455.343 207.114C452.141 195.457 450.442 184.616 451.211 180.76C451.258 180.524 451.406 180.315 451.615 180.193C451.824 180.072 452.08 180.045 452.31 180.126C452.782 180.288 463.825 184.083 466.508 187.839C468.76 190.987 480.12 226.234 475.832 235.41C474.928 237.345 473.533 237.844 472.515 237.925C472.414 237.932 472.313 237.939 472.211 237.939L472.225 237.925ZM452.748 182.068C452.08 191.115 460.171 224.441 468.638 233.994C470.02 235.559 471.288 236.3 472.394 236.219C472.926 236.179 473.701 235.977 474.308 234.682C478.266 226.207 467.303 191.843 465.139 188.816C463.359 186.322 456.321 183.375 452.755 182.068H452.748Z"
            fill="#682082"
          />
          <path
            d="M472.225 237.925C470.654 237.925 469.023 236.981 467.371 235.12C461.708 228.736 457.076 213.404 455.343 207.114C452.141 195.457 450.442 184.616 451.211 180.76C451.258 180.524 451.406 180.315 451.615 180.193C451.824 180.072 452.08 180.045 452.31 180.126C452.782 180.288 463.825 184.083 466.508 187.839C468.76 190.987 480.12 226.234 475.832 235.41C474.928 237.345 473.533 237.844 472.515 237.925C472.414 237.932 472.313 237.939 472.211 237.939L472.225 237.925Z"
            fill="white"
          />
          <path
            d="M472.225 237.925C470.654 237.925 469.023 236.981 467.371 235.12C461.708 228.736 457.076 213.404 455.343 207.114C452.141 195.457 450.442 184.616 451.211 180.76C451.258 180.524 451.406 180.315 451.615 180.193C451.824 180.072 452.08 180.045 452.31 180.126C452.782 180.288 463.825 184.083 466.508 187.839C468.76 190.987 480.12 226.234 475.832 235.41C474.928 237.345 473.533 237.844 472.515 237.925C472.414 237.932 472.313 237.939 472.211 237.939L472.225 237.925ZM452.748 182.068C452.08 191.115 460.171 224.441 468.638 233.994C470.02 235.559 471.288 236.3 472.394 236.219C472.926 236.179 473.701 235.977 474.308 234.682C478.266 226.207 467.303 191.843 465.139 188.816C463.359 186.322 456.321 183.375 452.755 182.068H452.748Z"
            fill="#682082"
          />
          <path
            d="M493.522 308.514L484.59 317.629L492.788 328.173L501.323 316.092L493.522 308.514Z"
            fill="white"
          />
          <mask
            id="mask4_3605_25314"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="484"
            y="308"
            width="18"
            height="21">
            <path
              d="M493.522 308.514L484.59 317.629L492.788 328.173L501.323 316.092L493.522 308.514Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_3605_25314)">
            <path
              d="M485.938 306.673L496.988 326.319L504.512 315.377L496.462 297.046L485.938 306.673Z"
              fill="#682082"
            />
          </g>
          <path
            d="M492.788 329.023C492.525 329.023 492.282 328.901 492.12 328.699L483.922 318.155C483.659 317.818 483.686 317.346 483.983 317.042L492.916 307.927C493.239 307.597 493.779 307.59 494.109 307.914L501.903 315.492C502.199 315.782 502.246 316.247 502.004 316.584L493.469 328.665C493.313 328.888 493.064 329.016 492.794 329.023H492.774H492.788ZM485.715 317.696L492.754 326.751L500.21 316.193L493.536 309.707L485.709 317.696H485.715Z"
            fill="#682082"
          />
          <path
            d="M487.104 315.552L494.21 326.859L492.215 338.597C492.215 338.597 498.882 341.132 498.822 343.485L484.684 343.107L475.953 316.941L487.104 315.552Z"
            fill="white"
          />
          <path
            d="M498.828 344.327C498.828 344.327 498.815 344.327 498.808 344.327L484.67 343.95C484.313 343.943 484.003 343.707 483.888 343.37L475.158 317.204C475.077 316.961 475.11 316.699 475.245 316.483C475.38 316.267 475.603 316.125 475.859 316.092L487.01 314.703C487.333 314.662 487.657 314.818 487.832 315.094L494.938 326.4C495.046 326.576 495.093 326.785 495.053 326.994L493.172 338.05C495.316 338.927 499.738 341.044 499.671 343.498C499.657 343.956 499.28 344.321 498.828 344.321V344.327ZM485.304 342.278L497.52 342.601C496.543 341.563 494.176 340.242 491.918 339.385C491.54 339.244 491.318 338.853 491.385 338.455L493.327 327.041L486.679 316.469L477.086 317.663L485.304 342.284V342.278Z"
            fill="#682082"
          />
          <path
            d="M447.968 150.67C447.968 150.67 431.417 146.537 425.362 160.082C423.947 163.251 413.214 160.979 409.634 164.572C404.038 170.188 408.454 178.204 405.13 178.932C398.759 180.335 392.449 177.153 386.968 182.634C381.669 187.933 388.148 196.765 388.296 199.374C388.68 206.123 383.293 208.382 390.979 217.011C395.503 222.088 403.162 223.666 410.241 222.803C431.565 220.207 448.993 200.709 444.961 180.254C442.574 168.165 444.354 154.803 447.968 150.67Z"
            fill="#682082"
          />
          <path
            d="M443.808 270.347L511.813 269.336L485.446 305.284L504.464 330.857C504.464 330.857 528.378 292.535 537.601 272.073C541.922 262.479 539.987 254.746 537.311 251.18C530.825 242.536 508.354 245.847 495.963 245.564C483.571 245.274 459.658 244.411 459.658 244.411L443.808 270.347Z"
            fill="#22CC7A"
          />
          <mask
            id="mask5_3605_25314"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x="443"
            y="244"
            width="98"
            height="87">
            <path
              d="M443.808 270.347L511.813 269.336L485.446 305.284L504.464 330.857C504.464 330.857 528.378 292.535 537.601 272.073C541.922 262.479 539.987 254.746 537.311 251.18C530.825 242.536 508.354 245.847 495.963 245.564C483.571 245.274 459.658 244.411 459.658 244.411L443.808 270.347Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask5_3605_25314)">
            <path
              d="M474.207 212.521C457.764 222.728 431.046 249.231 424.216 252.191C424.216 252.191 422.201 268.614 432.286 273.226C442.372 277.837 451.352 275.242 455.289 271.979C460.09 268.001 482.998 234.614 482.998 234.614L487.657 210.984C485.668 209.959 479.783 209.062 474.207 212.521Z"
              fill="#682082"
            />
          </g>
          <path
            d="M504.458 331.699C504.188 331.699 503.939 331.571 503.777 331.356L484.758 305.783C484.536 305.487 484.536 305.075 484.758 304.779L510.114 270.206L443.815 271.19H443.801C443.498 271.19 443.215 271.028 443.067 270.765C442.911 270.496 442.918 270.165 443.08 269.902L458.93 243.966C459.092 243.703 459.382 243.555 459.685 243.561C459.921 243.568 483.74 244.431 495.983 244.714C498.707 244.775 501.95 244.667 505.381 244.546C517.544 244.121 532.679 243.595 537.985 250.674C540.917 254.584 542.778 262.628 538.369 272.417C529.234 292.69 505.415 330.917 505.179 331.302C505.031 331.538 504.775 331.686 504.498 331.699C504.485 331.699 504.478 331.699 504.464 331.699H504.458ZM486.497 305.278L504.397 329.353C508.3 323.036 528.587 290.007 536.825 271.729C540.938 262.614 539.293 255.238 536.63 251.692C531.85 245.321 517.206 245.833 505.435 246.238C501.977 246.359 498.707 246.474 495.936 246.406C484.664 246.143 463.602 245.395 460.117 245.274L445.325 269.478L511.793 268.493C512.137 268.493 512.413 268.668 512.555 268.952C512.703 269.235 512.676 269.579 512.487 269.842L486.491 305.284L486.497 305.278Z"
            fill="#682082"
          />
          <path
            d="M422.389 184.285C422.389 184.285 438.907 173.336 456.584 182.748C456.584 182.748 467.836 227.138 459.82 240.129C459.82 240.129 420.286 247.869 421.115 247.869C421.944 247.869 417.245 239.577 416.416 219.667C415.587 199.758 422.396 184.285 422.396 184.285H422.389Z"
            fill="#E7C0ED"
          />
          <path
            d="M424.641 208.395L425.025 232.599L415.809 242.199L424.641 208.395Z"
            fill="#682082"
          />
          <path
            d="M421.108 248.712C420.67 248.712 420.293 248.382 420.252 247.943C420.232 247.728 420.239 247.566 420.299 247.431C420.218 247.107 420.05 246.575 419.888 246.062C418.769 242.482 416.16 234.102 415.56 219.701C414.731 199.826 421.54 184.097 421.607 183.942C421.675 183.78 421.796 183.645 421.951 183.557C422.133 183.45 440.033 173.033 458.748 182.789C459.166 183.005 459.321 183.517 459.105 183.928C458.89 184.339 458.377 184.501 457.966 184.286C441.219 175.555 425.174 183.712 423.057 184.872C422.201 186.955 416.504 201.532 417.259 219.627C417.852 233.812 420.421 242.044 421.513 245.557C421.675 246.069 421.796 246.474 421.89 246.797C422.099 246.75 422.329 246.703 422.585 246.649C423.643 246.427 425.16 246.116 426.974 245.752C430.601 245.017 435.448 244.06 440.289 243.096C448.851 241.404 457.42 239.725 459.281 239.354C462.82 233.125 462.685 218.339 458.89 197.614C458.809 197.156 459.112 196.711 459.571 196.63C460.036 196.549 460.474 196.853 460.555 197.311C463.339 212.514 465.598 232.363 460.541 240.561C460.42 240.763 460.218 240.905 459.982 240.945C445.426 243.797 423.616 248.099 421.52 248.611C421.398 248.672 421.263 248.699 421.115 248.699L421.108 248.712Z"
            fill="#682082"
          />
          <path
            d="M519.984 270.064L531.634 264.145L524.764 254.922L513.114 260.834L519.984 270.064Z"
            fill="white"
          />
          <path
            d="M519.984 270.914C519.721 270.914 519.472 270.792 519.303 270.57L512.433 261.34C512.285 261.138 512.231 260.882 512.285 260.639C512.339 260.396 512.501 260.194 512.723 260.079L524.373 254.16C524.744 253.971 525.189 254.079 525.438 254.409L532.308 263.639C532.456 263.841 532.51 264.097 532.457 264.34C532.403 264.583 532.241 264.785 532.018 264.9L520.368 270.819C520.247 270.88 520.112 270.914 519.984 270.914ZM514.395 261.138L520.24 268.985L530.36 263.841L524.515 255.994L514.395 261.138Z"
            fill="#682082"
          />
          <path
            d="M518.831 268.716L527.353 283.488C533.603 277.548 541.032 272.99 549.163 270.118L558.574 266.788C558.574 266.788 552.736 261.138 540.439 266.477L530.785 262.931L518.831 268.723V268.716Z"
            fill="white"
          />
          <path
            d="M527.346 284.33C527.306 284.33 527.265 284.33 527.225 284.324C526.969 284.283 526.739 284.135 526.611 283.906L518.09 269.134C517.975 268.932 517.948 268.689 518.016 268.46C518.083 268.237 518.245 268.048 518.454 267.947L530.407 262.156C530.616 262.055 530.852 262.041 531.068 262.122L540.412 265.554C552.871 260.282 558.905 265.925 559.154 266.167C559.363 266.37 559.458 266.673 559.39 266.956C559.329 267.246 559.12 267.475 558.844 267.576L549.432 270.907C541.363 273.759 534.122 278.195 527.919 284.094C527.764 284.243 527.548 284.33 527.333 284.33H527.346ZM520.018 269.08L527.548 282.139C533.751 276.442 540.918 272.127 548.88 269.316L556.754 266.531C554.55 265.284 549.352 263.531 540.783 267.246C540.58 267.334 540.358 267.34 540.156 267.266L530.838 263.841L520.025 269.08H520.018Z"
            fill="#682082"
          />
          <path
            d="M446.033 170.957L445.703 172.123C445.163 174.018 445.103 176.02 445.534 177.948L445.939 179.775C445.939 179.775 443.222 187.36 435.543 180.813L438.057 163.675L446.04 170.957H446.033Z"
            fill="white"
          />
          <path
            d="M441.192 184.319C439.311 184.319 437.228 183.362 434.99 181.454C434.767 181.265 434.66 180.975 434.7 180.685L437.215 163.547C437.262 163.237 437.471 162.981 437.767 162.873C438.064 162.765 438.394 162.833 438.624 163.048L446.606 170.33C446.842 170.546 446.936 170.876 446.849 171.186L446.518 172.352C446.019 174.105 445.966 175.98 446.363 177.759L446.768 179.587C446.802 179.742 446.795 179.903 446.741 180.058C446.694 180.193 445.527 183.355 442.561 184.144C442.123 184.259 441.664 184.319 441.199 184.319H441.192ZM436.446 180.463C438.63 182.236 440.538 182.924 442.109 182.513C443.855 182.054 444.779 180.308 445.055 179.694L444.705 178.13C444.246 176.074 444.307 173.917 444.887 171.887L445.076 171.226L438.657 165.374L436.446 180.47V180.463Z"
            fill="#682082"
          />
          <path
            d="M454.076 158.713C456.146 171.294 451.137 175.373 449.148 175.386C446.04 175.4 442.635 171.55 439.844 166.682C430.527 150.441 452.006 146.133 454.076 158.713Z"
            fill="white"
          />
          <path
            d="M449.127 176.229C446.687 176.229 444.071 174.334 441.354 170.593C441.078 170.215 441.165 169.682 441.543 169.413C441.92 169.136 442.453 169.224 442.723 169.602C445.042 172.784 447.314 174.537 449.127 174.537H449.141C449.492 174.537 450.334 174.24 451.258 173.148C452.613 171.543 454.669 167.559 453.24 158.848C453.166 158.39 453.476 157.951 453.941 157.877C454.4 157.803 454.838 158.113 454.912 158.578C456.449 167.956 454.096 172.42 452.552 174.247C451.507 175.487 450.233 176.229 449.154 176.236H449.127V176.229Z"
            fill="#682082"
          />
          <path
            d="M516.276 244.991H455.013L469.124 207.525H530.393L516.276 244.991Z"
            fill="#682082"
          />
          <path
            d="M516.276 245.833H455.013C454.737 245.833 454.474 245.699 454.319 245.469C454.164 245.24 454.123 244.95 454.224 244.687L468.342 207.229C468.463 206.898 468.78 206.683 469.13 206.683H530.393C530.67 206.683 530.933 206.817 531.088 207.047C531.243 207.276 531.283 207.566 531.182 207.829L517.065 245.287C516.944 245.618 516.627 245.833 516.276 245.833ZM456.233 244.141H515.69L529.167 208.375H469.71L456.233 244.141Z"
            fill="#682082"
          />
          <path
            d="M430.351 153.926L441.293 149.261C446.619 146.989 452.782 149.47 455.054 154.796L457.049 159.468L450.786 162.138C442.878 165.509 433.729 161.835 430.358 153.92L430.351 153.926Z"
            fill="#682082"
          />
          <path
            d="M424.756 183.396C424.756 183.396 415.088 184.67 411.629 197.729C410.2 203.13 404.092 221.839 403.512 238.168C403.202 247.034 411.481 248.2 414.461 247.391C417.441 246.575 422.625 213.708 424.115 208.489C426.805 199.078 427.196 187.191 424.756 183.396Z"
            fill="white"
          />
          <path
            d="M412.614 248.443C410.652 248.443 408.083 247.91 406.007 246.272C404.395 244.997 402.514 242.55 402.67 238.141C403.229 222.203 408.825 203.999 410.659 198.019L410.82 197.486C414.71 184.778 423.913 182.452 424.304 182.357C424.762 182.25 425.214 182.533 425.322 182.984C425.43 183.436 425.154 183.895 424.695 184.002C424.344 184.09 416.032 186.241 412.438 197.979L412.277 198.511C410.456 204.437 404.915 222.486 404.362 238.195C404.254 241.168 405.164 243.44 407.058 244.937C409.357 246.757 412.593 246.993 414.191 246.582C416.018 245.22 419.497 227.185 421.176 218.501C422.113 213.647 422.855 209.811 423.3 208.253C423.428 207.802 423.9 207.546 424.344 207.674C424.796 207.802 425.052 208.274 424.924 208.719C424.5 210.209 423.724 214.2 422.834 218.825C419.005 238.646 416.922 247.593 414.683 248.2C414.151 248.341 413.436 248.436 412.614 248.436V248.443Z"
            fill="#682082"
          />
          <path
            d="M439.615 167.485C437.963 172.406 432.556 175.029 432.556 175.029C432.556 175.029 429.819 169.676 431.471 164.754C433.122 159.832 438.529 157.21 438.529 157.21C438.529 157.21 441.266 162.563 439.615 167.485Z"
            fill="#682082"
          />
          <path
            d="M419.025 246.716C419.025 246.716 417.009 263.14 427.095 267.752C437.181 272.363 446.161 269.767 450.098 266.504C454.898 262.526 477.807 229.14 477.807 229.14L506.48 264.488L532.8 253.728C532.8 253.728 519.789 238.471 504.181 223.76C496.219 216.256 489.585 209.164 482.473 205.509C480.484 204.485 474.598 203.588 469.023 207.047C452.579 217.254 425.861 243.757 419.032 246.716H419.025Z"
            fill="#22CC7A"
          />
          <path
            d="M405.13 244.202C405.13 244.202 409.081 251.908 417.798 247.498C422.639 245.051 447.543 223.214 447.543 223.214C447.543 223.214 442.446 220.085 439.042 221.373C429.731 224.899 405.13 244.202 405.13 244.202Z"
            fill="white"
          />
          <path
            d="M412.688 249.71C407.085 249.71 404.409 244.653 404.375 244.586C404.193 244.229 404.288 243.784 404.604 243.534C405.616 242.745 429.414 224.111 438.745 220.578C442.494 219.162 447.766 222.351 447.988 222.486C448.217 222.627 448.366 222.87 448.386 223.133C448.406 223.403 448.305 223.666 448.103 223.841C447.085 224.738 423.057 245.773 418.182 248.247C416.113 249.292 414.286 249.703 412.695 249.703L412.688 249.71ZM406.249 244.404C407.342 246.009 410.895 250.04 417.421 246.737C421.594 244.626 441.536 227.326 446.073 223.369C444.503 222.587 441.475 221.353 439.352 222.155C431.059 225.29 410.052 241.444 406.249 244.397V244.404Z"
            fill="#682082"
          />
          <path
            d="M438.152 271.082C434.606 271.082 430.709 270.334 426.738 268.52C416.207 263.706 418.095 247.31 418.182 246.615C418.216 246.319 418.412 246.062 418.688 245.941C421.722 244.626 429.124 238.235 437.687 230.839C447.988 221.94 459.665 211.86 468.571 206.332C474.504 202.651 480.753 203.682 482.85 204.761C488.769 207.802 494.217 213.04 500.52 219.108C501.896 220.429 503.298 221.785 504.754 223.153C520.22 237.723 533.306 253.034 533.441 253.189C533.616 253.398 533.684 253.674 533.616 253.937C533.555 254.2 533.367 254.416 533.117 254.524L506.797 265.284C506.453 265.425 506.056 265.324 505.82 265.034L477.861 230.569C474.039 236.118 455.074 263.497 450.638 267.172C447.887 269.45 443.41 271.102 438.152 271.102V271.082ZM419.821 247.276C419.605 249.905 418.951 263.1 427.446 266.983C438.024 271.817 446.532 268.358 449.559 265.85C454.211 261.994 476.884 228.992 477.113 228.661C477.261 228.439 477.511 228.304 477.773 228.297C478.036 228.291 478.299 228.405 478.468 228.607L506.743 263.464L531.391 253.391C528.378 249.926 516.863 236.88 503.601 224.38C502.145 223.012 500.736 221.65 499.354 220.328C493.145 214.355 487.785 209.197 482.088 206.271C480.342 205.374 474.74 204.505 469.474 207.775C460.676 213.236 449.06 223.274 438.806 232.127C430.183 239.577 423.286 245.53 419.834 247.283L419.821 247.276Z"
            fill="#682082"
          />
          <path d="M92 45H243.5" stroke="#E7C0ED" strokeWidth="4" />
          <g clipPath="url(#clip0_3605_25314)">
            <path
              d="M364.342 50.2962C364.311 50.292 364.28 50.2878 364.248 50.28C363.688 50.1523 363.336 49.5966 363.464 49.0399C365.046 42.1168 369.153 36.0607 375.03 31.9886C380.943 27.8918 388.137 26.1672 395.288 27.1348C402.439 28.1023 408.918 31.6771 413.528 37.1978C418.111 42.6853 420.461 49.6151 420.146 56.7096C420.121 57.2802 419.634 57.7224 419.061 57.6968C418.483 57.6654 418.042 57.1861 418.067 56.6156C418.679 42.8402 408.767 31.0482 395.01 29.1867C381.253 27.3252 368.564 36.0591 365.493 49.5018C365.373 50.0283 364.869 50.3692 364.341 50.2979L364.342 50.2962Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M431.674 59.4069C431.135 59.3339 430.737 58.8553 430.775 58.3073C432.231 37.743 417.264 19.4545 396.704 16.6725C376.143 13.8904 356.854 27.5437 352.793 47.7554C352.68 48.3159 352.13 48.6749 351.569 48.5661C351.006 48.4534 350.64 47.9081 350.752 47.3476C355.03 26.0675 375.335 11.6934 396.983 14.6225C418.63 17.5516 434.385 36.8051 432.854 58.4567C432.813 59.0269 432.316 59.4556 431.742 59.4144C431.72 59.4114 431.698 59.4101 431.676 59.4071L431.674 59.4069Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M390.236 64.4694C386.401 63.9505 383.315 61.0672 382.559 57.2922C382.447 56.7307 382.811 56.1871 383.376 56.0744C383.94 55.9635 384.488 56.3273 384.601 56.8887C385.184 59.7958 387.561 62.0162 390.516 62.416C393.471 62.8158 396.351 61.3051 397.687 58.6594C397.944 58.148 398.57 57.9414 399.084 58.2C399.599 58.4569 399.806 59.0796 399.548 59.591C397.814 63.0272 394.073 64.9868 390.24 64.4681L390.236 64.4694Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M415.478 72.1141C415.331 72.0942 415.186 72.0434 415.053 71.9577C414.57 71.6462 414.432 71.005 414.743 70.5251C415.491 69.3761 416.156 68.1604 416.721 66.912C416.957 66.3908 417.57 66.16 418.098 66.3961C418.622 66.6318 418.855 67.2458 418.619 67.767C418.01 69.1083 417.294 70.416 416.491 71.6529C416.264 72.0002 415.865 72.1682 415.478 72.1158L415.478 72.1141Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M409.368 78.8544C409.113 78.8199 408.87 78.6917 408.697 78.4775C408.335 78.0315 408.406 77.3804 408.854 77.0214C409.925 76.1624 410.941 75.216 411.872 74.2097C412.26 73.7888 412.919 73.7618 413.343 74.1503C413.766 74.5371 413.794 75.1929 413.404 75.6135C412.404 76.6954 411.311 77.7127 410.159 78.6355C409.928 78.821 409.64 78.8912 409.366 78.8541L409.368 78.8544Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M401.447 83.3591C401.08 83.3096 400.751 83.0656 400.611 82.6963C400.408 82.1608 400.679 81.5645 401.217 81.3633C402.504 80.8821 403.765 80.2984 404.969 79.6307C405.47 79.3518 406.105 79.5313 406.386 80.0306C406.667 80.5299 406.488 81.161 405.986 81.44C404.693 82.158 403.336 82.7842 401.953 83.3028C401.786 83.3651 401.613 83.3816 401.447 83.3591Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M392.498 85.1568C392.006 85.0903 391.619 84.6807 391.597 84.1715C391.573 83.5995 392.02 83.1189 392.595 83.0961C393.973 83.0432 395.355 82.8853 396.705 82.6274C397.27 82.5201 397.815 82.8886 397.924 83.4495C398.032 84.0105 397.663 84.5535 397.099 84.661C395.648 84.938 394.16 85.1078 392.678 85.1656C392.616 85.1677 392.556 85.1647 392.496 85.1566L392.498 85.1568Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M385.756 89.8247L386.578 83.749C386.655 83.182 387.179 82.7865 387.747 82.8634C388.316 82.9403 388.716 83.4626 388.639 84.0279L388.191 87.3416L389.919 87.0691L391.715 83.6516C391.98 83.1448 392.61 82.9491 393.119 83.2157C393.629 83.4807 393.825 84.1071 393.56 84.6139L391.28 88.9509L385.756 89.8247Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M397.774 89.1013C397.608 89.0788 397.444 89.0289 397.291 88.9509C396.859 88.7312 396.558 88.3142 396.485 87.8361L395.873 83.7894C395.787 83.2229 396.179 82.6968 396.747 82.6123C397.314 82.5279 397.846 82.9188 397.931 83.4835L398.423 86.7424L399.929 85.9682L400.559 82.1624C400.65 81.6076 401.168 81.2304 401.725 81.3056C401.735 81.307 401.745 81.3084 401.755 81.3098C402.323 81.404 402.706 81.9361 402.614 82.5011L401.939 86.5904C401.864 87.0554 401.566 87.4625 401.143 87.6792L398.672 88.9488C398.393 89.0913 398.079 89.1425 397.776 89.1015L397.774 89.1013Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M407.548 85.4645C407.537 85.4631 407.529 85.4619 407.52 85.4608C407.04 85.3872 406.623 85.0844 406.404 84.6543L404.548 80.9993C404.29 80.4892 404.494 79.8666 405.007 79.6083C405.519 79.3499 406.145 79.556 406.406 80.0663L407.899 83.0081L409.085 81.804L408.484 77.991C408.395 77.4258 408.782 76.8973 409.35 76.8077C409.921 76.722 410.451 77.1076 410.541 77.6711L411.188 81.7659C411.261 82.2318 411.107 82.7104 410.777 83.0473L408.829 85.0258C408.496 85.3639 408.021 85.525 407.55 85.4613L407.548 85.4645Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M415.68 78.9611C415.356 78.9173 415.05 78.7701 414.813 78.5352L411.901 75.6424C411.494 75.2371 411.494 74.5833 411.899 74.1786C412.304 73.7739 412.963 73.7729 413.37 74.1783L415.715 76.5071L416.46 74.9935L414.689 71.5597C414.426 71.0508 414.627 70.4261 415.139 70.1658C415.651 69.9057 416.278 70.1067 416.54 70.6156L418.443 74.3047C418.66 74.7242 418.665 75.2277 418.456 75.652L417.233 78.1378C417.019 78.5718 416.606 78.8766 416.127 78.9557C415.977 78.9805 415.825 78.9825 415.678 78.9625L415.68 78.9611Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M421.346 70.2479C421.183 70.2259 421.021 70.1762 420.871 70.1004L417.195 68.261C416.681 68.0041 416.474 67.3813 416.732 66.87C416.989 66.3586 417.615 66.1537 418.129 66.4105L421.089 67.8931L421.321 66.2216L418.209 63.17L418.32 61.843C418.367 61.2737 418.871 60.8511 419.443 60.8991C420.015 60.94 420.441 61.4485 420.394 62.0178L420.364 62.3779L422.985 64.9486C423.322 65.2786 423.486 65.7551 423.421 66.2215L423.041 68.9653C422.975 69.4452 422.677 69.8645 422.248 70.089C421.968 70.235 421.651 70.2874 421.344 70.246L421.346 70.2479Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M436.465 65.2901L346.258 53.0841C344.561 52.8546 343.366 51.2934 343.594 49.6059L343.739 48.5365C343.967 46.849 345.535 45.6618 347.231 45.8913L437.438 58.0973C439.135 58.3269 440.33 59.888 440.102 61.5755L439.957 62.6449C439.729 64.3324 438.161 65.5197 436.465 65.2901ZM346.953 47.9433C346.394 47.8675 345.877 48.2588 345.802 48.8157L345.657 49.8851C345.582 50.4419 345.976 50.9564 346.536 51.0322L436.743 63.2382C437.302 63.3139 437.819 62.9226 437.894 62.3658L438.039 61.2964C438.114 60.7396 437.72 60.225 437.161 60.1493L346.953 47.9433Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M387.553 92.0638L386.523 91.9243C377.215 90.6649 368.817 85.9842 362.875 78.747C356.962 71.5432 354.024 62.4878 354.602 53.244C354.638 52.6731 355.132 52.2406 355.706 52.2766C356.278 52.3124 356.715 52.8051 356.68 53.376C355.575 71.0591 368.283 86.8206 385.772 89.7194L389.346 63.305C389.423 62.738 389.947 62.3425 390.515 62.4194C391.084 62.4963 391.484 63.0186 391.407 63.5839L387.553 92.0655L387.553 92.0638Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M399.56 55.0615C399.068 54.995 398.681 54.5854 398.659 54.0761C398.517 50.6703 395.945 47.8652 392.545 47.4052C389.145 46.9452 385.919 48.9657 384.876 52.2111C384.701 52.7562 384.117 53.0586 383.569 52.8804C383.021 52.7057 382.719 52.1239 382.894 51.5788C384.243 47.3742 388.42 44.7575 392.823 45.3533C397.226 45.9491 400.555 49.5832 400.74 53.9935C400.763 54.5654 400.317 55.046 399.743 55.069C399.682 55.0711 399.62 55.0679 399.56 55.0598L399.56 55.0615Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M354.814 39.0953C354.531 39.0571 354.267 38.9053 354.094 38.6529L347.191 28.617C345.83 26.5913 345.263 24.1564 345.588 21.7554L346.651 13.8951C347.688 6.23237 354.797 0.847815 362.501 1.89021L383.88 4.78297C387.769 5.30927 391.222 7.31107 393.603 10.4181L397.064 14.937C397.412 15.3916 397.324 16.0421 396.868 16.3878C396.411 16.7335 395.757 16.6451 395.409 16.1905L391.948 11.6715C389.905 9.00388 386.94 7.28659 383.602 6.83489L362.223 3.94212C355.658 3.05377 349.598 7.64388 348.714 14.1742L347.651 22.0345C347.393 23.9366 347.842 25.8631 348.915 27.4596L355.811 37.4858C356.135 37.9581 356.015 38.6025 355.541 38.925C355.32 39.0754 355.06 39.1287 354.814 39.0953Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M360.222 30.7376C359.918 30.6963 359.635 30.5211 359.465 30.2381L356.888 25.9045C356.424 25.1221 356.233 24.1964 356.355 23.2973L357.304 16.2867C357.785 12.7295 361.087 10.2268 364.665 10.7109L382.375 13.1073C383.941 13.3192 385.84 13.9854 386.473 15.2224C386.734 15.7328 386.531 16.3556 386.02 16.6142C385.509 16.8728 384.881 16.6699 384.62 16.1612C384.498 15.921 383.606 15.3633 382.097 15.1592L364.387 12.7628C361.948 12.4328 359.695 14.1376 359.366 16.5659L358.418 23.5764C358.358 24.0175 358.45 24.4704 358.679 24.8533L361.257 29.1869C361.549 29.679 361.387 30.3142 360.891 30.6043C360.682 30.727 360.446 30.7696 360.222 30.7393L360.222 30.7376Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M376.289 19.152L369.715 18.2625C368.132 18.0483 367.017 16.5935 367.231 15.0184L367.618 12.1543C367.695 11.5872 368.219 11.1917 368.787 11.2686C369.356 11.3455 369.756 11.8678 369.679 12.4332L369.292 15.2973C369.232 15.7401 369.546 16.1502 369.991 16.2104L376.565 17.0999C377.135 17.177 377.533 17.6991 377.457 18.2645C377.38 18.8298 376.856 19.227 376.287 19.1501L376.289 19.152Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M412.902 49.825C412.515 49.7727 412.173 49.5044 412.048 49.1096C410.908 45.5168 408.827 42.2665 406.028 39.7099C405.605 39.3231 405.576 38.6673 405.965 38.2465C406.353 37.8256 407.01 37.7984 407.436 38.1854C410.503 40.9882 412.784 44.5515 414.033 48.4885C414.206 49.034 413.901 49.6152 413.353 49.7873C413.202 49.8344 413.049 49.8449 412.902 49.825Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
            <path
              d="M385.493 34.783C385.089 34.7283 384.738 34.438 384.625 34.0205C384.477 33.4681 384.808 32.9008 385.363 32.7539C388.377 31.96 391.486 31.7721 394.603 32.1939C395.173 32.2711 395.572 32.7931 395.495 33.3585C395.419 33.9238 394.894 34.321 394.326 34.2441C391.482 33.8594 388.647 34.0306 385.9 34.7547C385.764 34.7901 385.625 34.7974 385.494 34.7795L385.493 34.783Z"
              fill="#682082"
              stroke="#682082"
              strokeWidth="0.5"
            />
          </g>
          <g clipPath="url(#clip1_3605_25314)">
            <path
              d="M105.938 282.049L34.0905 277.814L73.667 218.099L105.938 282.049Z"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.667 218.099L105.938 282.049L127.138 268L90.178 219.072L73.667 218.099Z"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M55.8558 279.097C69.1245 279.879 73.0732 242.893 72.6093 236.044C72.6093 236.044 78.8149 266.071 89.5763 281.085"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M72.6103 236.028C72.6103 236.028 62.2858 267.388 47.1108 278.565"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34.0905 277.814L27.6315 280.677L27.492 283.043"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M106.017 282.121L111.362 285.98L111.214 288.496"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M127.138 268L132.65 270.448L132.52 272.664"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.667 218.099L69.5172 208.675"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M78.9782 209.233L73.667 218.099"
              stroke="#682082"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3605_25314">
              <rect
                width="99"
                height="86"
                fill="white"
                transform="translate(348.532) rotate(7.70594)"
              />
            </clipPath>
            <clipPath id="clip1_3605_25314">
              <rect
                width="107"
                height="80"
                fill="white"
                transform="translate(30.7072 205) rotate(3.37323)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default NoItemsFound;
